import styled from 'styled-components'

export const HelpText = styled.span`
  background: ${({ theme }) => theme.colors.sagelight};
  color: ${({ theme }) => theme.colors.blackToSandstone};
  bottom: calc(100% + 12px);
  display: block;
  left: -9999px;
  opacity: 0;
  padding: 15px 20px;
  position: absolute;
  transform: scale(0.7);
  transform-origin: 24px calc(100% + 12px);
  transition: opacity 0.2s ease, transform 0.2s ease, visiblity 0s 0.2s,
    left 0s 0.2s;
  visiblity: hidden;
  width: max-content;

  ${({ maxWidth }) =>
    !!maxWidth &&
    `
    max-width: ${maxWidth};
  `}

  &::before {
    border: 5.5px solid transparent;
    border-bottom: 0 none;
    border-top: 6px solid ${({ theme }) => theme.colors.sagelight};
    content: '';
    display: block;
    height: 0;
    left: 24px;
    position: absolute;
    top: 100%;
    width: 0;
  }
`

export const Wrapper = styled.span`
  display: inline-block;
  margin-left: 3px;
  top: -3px;
  position: relative;

  &:hover ${HelpText} {
    left: -16px;
    opacity: 1;
    transform: scale(1);
    transition: opacity 0.3s ease,
      transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    visiblity: visible;
  }
`

export const Icon = styled.span`
  display: inline-block;
  margin-left: 10px;
  position: relative;

  &::before {
    background: ${({ theme }) => theme.colors.sagemediumToGreen};
    border-radius: 100%;
    content: '';
    display: block;
    height: 16px;
    left: calc(50% - 7.5px);
    position: absolute;
    top: calc(50% - 8px);
    width: 16px;
  }
`

export const Qmark = styled.span`
  color: ${({ theme }) => theme.colors.white};
  display: inline-block;
  position: relative;
`
